import React from "react";

const MainDatePicker = ({ handleChange }) => {
  return <input className="date-picker" onChange={handleChange} type="date" />;
};

export default MainDatePicker;
